import * as z from "zod";
import { defineIntegrationSettings } from "../define-settings";

export const linxSettings = defineIntegrationSettings({
  fields: { enabled: z.boolean() },
  secrets: {},
  connectOnly: {},
  computed: {},
});
